import {OverviewState} from '../reducers/overview';
import {safelyToJS} from './utils';

export const selectOverview = (state): OverviewState => safelyToJS(state.get('overview'));
